import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import './index.scss';
import { sidebarData } from './SidebarData';

const Sidebar = ({ isOpen: externalIsOpen, onClose }) => {
    const [isOpen, setIsOpen] = useState(true);
    const [openDropdown, setOpenDropdown] = useState(null);
    const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    // Use external state if provided, otherwise use internal state
    const sidebarIsOpen = externalIsOpen !== undefined ? externalIsOpen : isOpen;

    const toggleSidebar = () => {
        if (externalIsOpen !== undefined && onClose) {
            onClose();
        } else {
            setIsOpen(!isOpen);
        }
    };

    const toggleDropdown = (index) => {
        setOpenDropdown(openDropdown === index ? null : index);
    };

    const isActive = (path) => {
        return location.pathname === path;
    };

    const hasActiveSubmenu = (subMenu) => {
        return subMenu?.some(item => location.pathname === item.path);
    };

    const handleLogoutClick = () => {
        setShowLogoutConfirm(true);
    };

    const handleLogoutConfirm = () => {
        // Clear all localStorage data
        localStorage.clear();

        // Clear all sessionStorage data
        sessionStorage.clear();

        // Close the modal
        setShowLogoutConfirm(false);

        // Show success message
        toast.success('Logged out successfully');

        // Redirect to login page
        navigate('/login');
    };

    const handleLogoutCancel = () => {
        setShowLogoutConfirm(false);
    };

    return (
        <>
            <div className={`sidebar ${sidebarIsOpen ? 'open' : 'closed'}`}>
                <div className="sidebar-header">
                    <h2>{sidebarIsOpen ? 'OnBoarding Portal' : 'D'}</h2>
                    {/* <button className="toggle-btn" onClick={toggleSidebar}>
                        {sidebarIsOpen ? '←' : '→'}
                    </button> */}
                </div>

                <ul className="sidebar-menu">
                    {sidebarData.map((item, index) => (
                        <li
                            key={index}
                            className={`sidebar-item ${(item.path && isActive(item.path)) ||
                                (item.subMenu && hasActiveSubmenu(item.subMenu))
                                ? 'active' : ''
                                }`}
                        >
                            {item.subMenu ? (
                                <>
                                    <div
                                        className="sidebar-link"
                                        onClick={() => sidebarIsOpen && toggleDropdown(index)}
                                    >
                                        <span className="icon">{item.icon}</span>
                                        {sidebarIsOpen && (
                                            <>
                                                <span className="title">{item.title}</span>
                                                <span className={`arrow ${openDropdown === index ? 'open' : ''}`}>
                                                    ▼
                                                </span>
                                            </>
                                        )}
                                    </div>
                                    {sidebarIsOpen && openDropdown === index && (
                                        <ul className="submenu">
                                            {item.subMenu.map((subItem, subIndex) => (
                                                <li key={subIndex}>
                                                    <a
                                                        href={subItem.path}
                                                        className={isActive(subItem.path) ? 'active' : ''}
                                                    >
                                                        {subItem.title}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </>
                            ) : (
                                <a href={item.path}>
                                    <span className="icon">{item.icon}</span>
                                    {sidebarIsOpen && <span className="title">{item.title}</span>}
                                </a>
                            )}
                        </li>
                    ))}
                </ul>

                <div className="sidebar-footer">
                    <button className="logout-btn" onClick={handleLogoutClick} title="Logout">
                        <span className="icon">🚪</span>
                        {sidebarIsOpen && <span className="title">Logout</span>}
                    </button>
                </div>
            </div>

            {showLogoutConfirm && (
                <div className="logout-modal-overlay" onClick={handleLogoutCancel}>
                    <div className="logout-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="logout-modal-icon">⚠️</div>
                        <h3>Confirm Logout</h3>
                        <p>Are you sure you want to logout?</p>
                        <div className="logout-modal-actions">
                            <button className="btn-cancel" onClick={handleLogoutCancel}>
                                Cancel
                            </button>
                            <button className="btn-confirm" onClick={handleLogoutConfirm}>
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Sidebar;
